module.exports = __webpack_public_path__ + "static/media/a-2-c.522dcd0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-2-c.jpg
// module id = 1094
// module chunks = 33